import React from 'react';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  style?: React.CSSProperties;
}

export function Spinner({ size = 'md', style }: SpinnerProps) {
  return <span className={'spinner ' + size} style={style} />;
}

export interface LoadingBlockProps {
  label?: string;
}

export function LoadingBlock({ label = 'Loading…' }: LoadingBlockProps) {
  return (
    <div
      className="col"
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        padding: 40,
        color: 'var(--text-muted)',
      }}
    >
      <span className="spinner lg" />
      <div style={{ fontSize: 'var(--fs-sm)' }}>{label}</div>
    </div>
  );
}

export default Spinner;
